import { useState } from 'react';
import { useAuth } from '../AuthContext';
import { HardHat } from 'lucide-react';

export default function LoginGate() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || 'Unable to sign in');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 rounded-2xl p-10 text-center shadow-xl max-w-sm w-full">
        <HardHat className="w-12 h-12 text-blue-400 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-white mb-2">Opsive</h1>
        <p className="text-gray-400 text-sm mb-8">Operations software for teams in motion.</p>
        <form onSubmit={submit} className="space-y-3 text-left">
          <label className="block text-xs text-gray-400" htmlFor="opsive-email">Email</label>
          <input id="opsive-email" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} className="w-full rounded-lg border border-gray-700 bg-gray-900 px-3 py-2.5 text-sm text-white outline-none focus:border-blue-400" />
          <label className="block text-xs text-gray-400" htmlFor="opsive-password">Password</label>
          <input id="opsive-password" type="password" autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} className="w-full rounded-lg border border-gray-700 bg-gray-900 px-3 py-2.5 text-sm text-white outline-none focus:border-blue-400" />
          {error && <p role="alert" className="text-sm text-red-400">{error}</p>}
          <button disabled={submitting} className="block w-full py-3 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white font-semibold rounded-xl transition-colors">
            {submitting ? 'Signing in…' : 'Sign in with SharpWithIt'}
          </button>
        </form>
        <p className="text-xs text-gray-600 mt-4">Use your shared SharpWithIt account — no separate signup needed.</p>
      </div>
    </div>
  );
}
